import React, { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

type Props = {
    readonly value: string;
    readonly disabled: boolean;
    readonly onChange: (value: string) => void;
    readonly onFocus?: () => void;
    readonly onBlur?: () => void;
    readonly onReset: () => void;
};

export const FilterQuickSearch: FC<Props> = ({ value, disabled, onChange, onFocus, onBlur, onReset }) => {
    const { t } = useTranslation();
    return (
        <div className={classNames('quicksearch')}>
            <input
                type="text"
                value={value}
                placeholder={t('components.searchBar.shopSearch')}
                onFocus={onFocus}
                onBlur={onBlur}
                onChange={e => onChange(e.target.value)}
                disabled={disabled}
            />
            <div className="icon-search">
                <i className="material-icons md-upper">search</i>
            </div>
            {value.length > 0 && (
                <div className="icon-close">
                    <a onClick={onReset} title="reset search" aria-label="Reset">
                        <i className="material-icons md-upper">clear</i>
                    </a>
                </div>
            )}
        </div>
    );
};
